import React, { Component } from 'react'
import { Link } from 'react-router-dom';

class ConditionalLink extends Component {
   

    render() {



        if(this.props.active) {
            return (
            
                
                <Link 
                    className={this.props.className}
                    target={this.props.newWindow ? '_blank' : '_self'} 
                    to={this.props.url}   
                >
                    {this.props.children}
                </Link>
                        
                            
            )
        }
        else {
            return (
            <span className={this.props.className + " inactive"}>
                {this.props.children}
            </span>
            )
        }
    
    }

}

export default ConditionalLink;


ConditionalLink.defaultProps = {

    url : '/',
    active : true,
    className : '',
    newWindow : false,
}

